import { render, staticRenderFns } from "./PiechartTest.vue?vue&type=template&id=949af6d8&"
import script from "./PiechartTest.vue?vue&type=script&lang=js&"
export * from "./PiechartTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports